import { erpAxios } from '..';

const komitentCount = async (uName) => {
  const { data } = await erpAxios(`/komitenti/count/${uName}`);
  return data;
};

export default komitentCount;
